// extracted by mini-css-extract-plugin
export default {"container":"pSvIGYGdoqNh3r2v9KOA","slider":"xphfManyPeN6swgYJxd4"};